export default function auth(state = {}, action) {
  switch (action.type) {
    default:
      return state;
  }
}